import React, { Fragment } from 'react';
import PropTypes from 'proptypes';
import './RegistrationHeader.scss';

const RegistrationHeader = ({ user, hasPaidDeposit }) => {
  const applicationStage = user === undefined || Object.keys(user).length === 0;

  const tripSelectionStage =
    user &&
    user.approved &&
    (user.trips === undefined ||
      (user.pastTrips && user.pastTrips.length && !user.trips.length));

  const makeDepositStage =
    user && user.approved && user.trips && user.trips.length && !hasPaidDeposit;

  const applyHeader = (
    <Fragment>
      <div className={`registration-circle ${applicationStage ? 'circle-active' : ''}`}>
        <p
          className={`registration-circle-text ${
            applicationStage ? 'registration-circle-text-active' : ''
          }`}
        >
          1
        </p>
      </div>
      <h6 className={`registration-text ${applicationStage ? 'text-active' : ''}`}>Application</h6>
    </Fragment>
  );

  const tripListHeader = (
    <Fragment>
      <div className={`registration-circle ${tripSelectionStage ? 'circle-active' : ''}`}>
        <p
          className={`registration-circle-text ${
            tripSelectionStage ? 'registration-circle-text-active' : ''
          }`}
        >
          2
        </p>
      </div>
      <h6 className={`registration-text ${tripSelectionStage ? 'text-active' : ''}`}>
        Select a Trip
      </h6>
    </Fragment>
  );

  const depositHeader = (
    <Fragment>
      <div className={`registration-circle ${makeDepositStage ? 'circle-active' : ''}`}>
        <p
          className={`registration-circle-text ${
            makeDepositStage ? 'registration-circle-text-active' : ''
          }`}
        >
          3
        </p>
      </div>
      <h6 className={`registration-text ${makeDepositStage ? 'text-active' : ''}`}>Secure Spot</h6>
    </Fragment>
  );

  return !user.approved && Object.keys(user).length > 0 ? (
    ''
  ) : (
    <div className="row">
      <div className="registration-header-container col-md-12">
        <div className="registration-col">{applyHeader}</div>
        <div className="registration-col">{tripListHeader}</div>
        <div className="registration-col">{depositHeader}</div>
      </div>
    </div>
  );
};

RegistrationHeader.propTypes = {
  hasPaidDeposit: PropTypes.bool.isRequired,
};

export default RegistrationHeader;
